(() => {
  if (window.gpToolsAsyncFilters) return;
  window.gpToolsAsyncFilters = true;
  const states = new WeakMap();
  const key = url => url.pathname + url.search;
  const localURL = (root, value) => {
    const url = new URL(value, location.href);
    const base = new URL(root.dataset.collectionUrl, location.origin).pathname.replace(/\/$/, '');
    return url.origin === location.origin && (url.pathname === base || url.pathname.startsWith(base + '/')) ? url : null;
  };
  const ready = root => root?.dataset.sectionId && root.querySelector('[data-gtools-results]');
  function stateFor(root) {
    if (!states.has(root)) states.set(root, { sequence: 0, cache: new Map([[key(new URL(location.href)), { html: root.outerHTML, at: Date.now() }]]) });
    return states.get(root);
  }
  async function navigate(root, url, { historyMode = 'push', focus, pagination = false } = {}) {
    const state = stateFor(root), sequence = ++state.sequence;
    state.controller?.abort();
    const controller = new AbortController();
    state.controller = controller;
    const status = root.querySelector('[data-gtools-status]');
    const zh = document.documentElement.lang.startsWith('zh');
    root.querySelector('[data-gtools-results]').setAttribute('aria-busy', 'true');
    status.textContent = zh ? '正在更新商品…' : 'Updating products…';
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const cached = state.cache.get(key(url));
      let html;
      if (cached && Date.now() - cached.at < 300000) html = cached.html;
      else {
        const endpoint = new URL(url);
        endpoint.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(endpoint.href, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Section request failed');
        html = await response.text();
      }
      if (sequence !== state.sequence) return;
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gtools]');
      const results = next?.querySelector('[data-gtools-results]');
      if (!results || next.dataset.handle !== root.dataset.handle || html.includes('Liquid error')) throw new Error('Invalid section');
      state.cache.set(key(url), { html, at: Date.now() });
      if (state.cache.size > 12) state.cache.delete(state.cache.keys().next().value);
      root.querySelector('[data-gtools-results]').replaceWith(results);
      const oldNav = root.querySelector('.gtools-nav'), newNav = next.querySelector('.gtools-nav');
      if (oldNav && newNav) {
        const oldLinks = [...oldNav.querySelectorAll('a')], newLinks = [...newNav.querySelectorAll('a')];
        if (oldLinks.length === newLinks.length) {
          oldLinks.forEach((link, index) => {
            const fresh = newLinks[index];
            link.href = fresh.href;
            link.className = fresh.className;
            if (fresh.hasAttribute('aria-current')) link.setAttribute('aria-current', fresh.getAttribute('aria-current'));
            else link.removeAttribute('aria-current');
          });
        } else oldNav.replaceWith(newNav);
      }
      if (historyMode === 'push' && key(url) !== key(new URL(location.href))) history.pushState(history.state, '', url.href);
      status.textContent = (zh ? '已更新：' : 'Updated: ') + (root.querySelector('.gtools-count')?.textContent.trim() || '');
      if (focus?.type === 'select') root.querySelectorAll('[data-gtools-navigate], [data-gtools-sort]')[focus.index]?.focus({ preventScroll: true });
      if (focus?.type === 'link') [...root.querySelectorAll('.gtools-nav a')].find(a => a.href === focus.href)?.focus({ preventScroll: true });
      if (pagination) {
        const toolbar = root.querySelector('.gtools-toolbar');
        toolbar.setAttribute('tabindex', '-1');
        toolbar.focus({ preventScroll: true });
        toolbar.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    } catch (error) {
      if (sequence !== state.sequence) return;
      status.textContent = zh ? '暫時未能更新，請再試或' : 'Unable to update. Try again or ';
      const link = document.createElement('a');
      link.href = url.href;
      link.textContent = zh ? '開啟篩選結果' : 'open the filtered results';
      status.append(link);
      root.querySelectorAll('[data-gtools-navigate], [data-gtools-sort]').forEach(select => {
        select.value = [...select.options].find(option => option.defaultSelected)?.value || select.options[0].value;
      });
    } finally {
      clearTimeout(timer);
      if (sequence === state.sequence) root.querySelector('[data-gtools-results]').removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('.gtools-nav a, .gtools-active a, .gtools-pagination a');
    const root = link?.closest('[data-gtools]');
    if (!ready(root) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = localURL(root, link.href);
    if (!url) return;
    event.preventDefault();
    navigate(root, url, { focus: { type: 'link', href: link.href }, pagination: !!link.closest('.gtools-pagination') });
  });
  document.addEventListener('change', event => {
    const select = event.target, root = select.closest('[data-gtools]');
    if (!root || !select.matches('[data-gtools-navigate], [data-gtools-sort]')) return;
    if (!ready(root)) {
      if (select.matches('[data-gtools-navigate]')) location.assign(select.value);
      else select.form.requestSubmit();
      return;
    }
    let url;
    if (select.matches('[data-gtools-navigate]')) url = localURL(root, select.value);
    else {
      url = new URL(location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
    }
    if (url) navigate(root, url, { focus: { type: 'select', index: [...root.querySelectorAll('[data-gtools-navigate], [data-gtools-sort]')].indexOf(select) } });
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('.gtools-sort'), root = form?.closest('[data-gtools]');
    if (!ready(root)) return;
    event.preventDefault();
    const url = new URL(location.href);
    url.searchParams.set('sort_by', form.querySelector('[data-gtools-sort]').value);
    url.searchParams.delete('page');
    navigate(root, url);
  });
  window.addEventListener('popstate', () => {
    document.querySelectorAll('[data-gtools]').forEach(root => {
      if (!ready(root)) return;
      const url = localURL(root, location.href);
      if (url) navigate(root, url, { historyMode: 'none' });
    });
  });
})();
